import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
  HazardTable,
} from './DocumentPage';

const JetWashPressureWasherDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Jet Wash / Pressure Washers – RA & SSOW"
    documentHeading="Risk Assessment 03 & Safe System of Work: Pressure Washers"
    meta={[
      ['Document Reference', 'PVS-RAMS-PW-001'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Workshops / Yard Area'],
      ['Activity', 'Use of jet wash / pressure washers to clean vehicles and other items'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Jet Wash / Pressure Washers – RA & SSOW',
      documentReference: 'PVS-RAMS-PW-001',
      processActivity: 'Use of Pressure Washers',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        There are a number of hazards present when using a pressure washer, for example electrocution
        / burns / fire from faulty equipment, pressure injection injuries e.g. water being injected
        into the skin from a high pressure water jet, and eye injury from water jet and / or debris.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazard Category', 'Hazards', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            'Pressure Washer and other Electrical Equipment',
            [
              'Electrocution / burns / fire from faulty equipment.',
              'Pressure injection injuries e.g. water being injected into the skin from high pressure water jet.',
              'Eye injury from water jet and/or debris etc.',
              'Slips, trips and falls from wet slippery floors, uneven floors, items left on the floor, inappropriate footwear, trailing cables etc. resulting in sprain, broken bones etc.',
            ],
            [
              'Staff have been provided with sufficient information, instruction and training.',
              'Periodic inspections of the pressure washer, RCD etc. are undertaken.',
              'Staff do not aim the water jet either at themselves or others.',
              'PPE is provided (safety glasses, safety footwear, etc).',
              'Drainage is adequate. Staff have been instructed to report any signs of blocked drains to their supervisor / manager straight away.',
              'The floor is in a good state of repair and surfaces are cleaned at regular intervals.',
              'Trailing cables are kept to a minimum.',
            ],
            [
              'Ensure the equipment is electrically tested and / or serviced / maintained at regular intervals.',
              'Consider the use of an RCD device to protect the user against electrocution.',
            ],
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Use a residual current device (RCD) or earth monitoring device with pressure washers, and check that it is working daily.',
          'Carry out a visual check of the equipment before use. Check flexible cables and plugs / sockets daily for damage (e.g. splits or cuts in the cable sheath, or any slippage of the cable in the cable grip at either end – you should not be able to see the brown, blue or green wires). Check for loose or broken covers over electrical parts and do not use if damaged or faulty. Report defects.',
          'Check the cover that covers the plug (where fitted) is in place.',
          'Wear impact resistant eye protection (standard spectacles are not adequate) when operating the pressure washer.',
          'Stay alert and watch what you are doing.',
          'Check other persons are away from the working area.',
          'Hold the gun and lance firmly with two hands.',
          'Keep good footing and balance at all times.',
          'Check the trailing cable / hose is kept to a minimum. Keep cables out of the water.',
          'Check you have a clear field of vision when operating the pressure washer.',
          'Squeeze the trigger to release residual pressure before switching off the machine.',
          'Remember high-pressure jets can cause damage to fragile items e.g. vehicle tyres / tyre valves may be damaged or burst. Always take care when aiming the water jet and maintain a safe distance from the object / surface being cleaned.',
          'Unplug the pressure washer from the power supply before any repair work, servicing or maintenance work is undertaken.',
          'Remember frost will damage the pressure washer – store indoors to prevent frost damage.',
        ]}
        doNotItems={[
          'Operate any defective equipment.',
          'Pull or carry the equipment by its power supply lead.',
          'Pull power plugs from sockets by the power cable.',
          'Misuse the equipment.',
          'Direct water jets at the machine itself, other electrical equipment, yourself, vulnerable items or other people.',
          'Lock the trigger in the "on" position.',
          'Leave cables / hoses where they can be run over by vehicles or tripped over by pedestrians.',
          'Touch the plug and mains socket with wet hands.',
          'Let electrical connections rest in water.',
          'Use the pressure washer to spray objects containing hazardous materials e.g. asbestos.',
          'Leave the pressure washer unattended when it is turned on.',
        ]}
      />
    </Section>

    <Section number="4" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only to
        protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default JetWashPressureWasherDoc;
